import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/California.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Revolutionizing App Development In California</h2>
            <p>
              We're at the forefront of California's digital revolution,
              powering the transformation of businesses and lives with our
              cutting-edge mobile applications.
            </p>
            <p>
              Our expert team combines the latest technologies with a deep
              understanding of the California market, resulting in apps that not
              only meet but exceed expectations. We are the catalysts for
              progress, leveraging the power of mobile technology to push
              boundaries, unlock opportunities, and foster digital excellence
              across the state.
            </p>
            <p>
              Join us on this journey of transformation, as we continue to fuel
              California's digital evolution with unmatched innovation and
              unwavering commitment to excellence.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
